import React, {useEffect} from "react";
import {SubNavBar} from "../../components/subnavbar/SubNavBar";
import {useParams} from 'react-router-dom'
import {Overview} from "./Overview";
import {Specs} from "./Specs";
import {Buy} from "./Buy";
import {Info} from "./Info";


export const GoodPage = ({good}) => {
    const {page} = useParams()

    useEffect(() => {
        console.log(good, page)
    }, [])

    return (
        <div>
            <SubNavBar good={good}/>
            <div className='container-sm'>
                <h2>{good.name}</h2>
                {!page ? <Info good={good}/> : ''}
                {page && page === 'overview' ? <Overview good={good}/> : ''}
                {page && page === 'specs' ? <Specs good={good}/> : ''}
                {page && page === 'buy' ? <Buy good={good}/> : ''}
            </div>
        </div>
    )
}